/* eslint-disable react/no-multi-comp */
/* eslint-env node, browser */

import React, { useCallback, useRef, useState } from 'react';

import PageTemplate, {
  pageCommonPropTypes,
  renderCmsComponents,
  renderComponent,
} from './templates/PageTemplate';

const getFilteredArticleDescriptors = ({ collection, tabId }) => {
  // If the tabId is 'all', we return the entire collection
  if (tabId === 'all') {
    return collection;
  }

  // The tabId is the topicId of the selected tab
  return collection.filter((item) => {
    const { topicGroup } = item;
    return topicGroup?.topic?.topicId === tabId;
  });
};

const TabControllerTemplate = ({
  articleFeatureSection,
  articleStackSection,
  pageInfo,
}) => {
  const [selectedTabId, setSelectedTabId] = useState(
    articleFeatureSection.tabController.selectedTab,
  );

  const changeSelectedTabId = useCallback(
    (tabId) => setSelectedTabId(tabId),
    [],
  );
  // Storing the initial collections so we can use it to filter our entries
  const initialStandardCardsRef = useRef(articleStackSection?.collection || []);
  const initialFeatureCardsRef = useRef(
    articleFeatureSection?.featureCards || [],
  );

  const updatedArticleFeatureSection = {
    ...articleFeatureSection,
    tabController: {
      ...articleFeatureSection.tabController,
      selectedTab: selectedTabId,
      onClick: (tabId) => {
        if (typeof window === 'undefined') {
          return;
        }

        // Update selected tab state
        changeSelectedTabId(tabId);

        // Update URL query param
        const url = new URL(window.location);

        if (tabId === 'all') {
          url.searchParams.delete('topic');
        } else {
          url.searchParams.set('topic', tabId);
        }

        window.history.replaceState({}, '', url);
      },
    },
    featureCards: getFilteredArticleDescriptors({
      collection: initialFeatureCardsRef.current,
      tabId: selectedTabId,
    }),
  };
  const updatedArticleStackSection = {
    ...articleStackSection,
    collection: getFilteredArticleDescriptors({
      collection: initialStandardCardsRef.current,
      tabId: selectedTabId,
    }),
  };

  return (
    <>
      {renderComponent({
        componentData: updatedArticleFeatureSection,
        pageInfo,
      })}
      {articleStackSection &&
        renderComponent({
          componentData: updatedArticleStackSection,
          pageInfo,
        })}
    </>
  );
};

const CategoryPage = ({ content = {}, fpti = {}, pageInfo = {} }) => {
  const {
    components = [],
    subNav,
    aboveHeader,
    globalDisclosure,
    articleStickyButton,
  } = content.pageData || {};

  const articleFeatureSection = components.find(
    (component) => component.componentType === 'ArticleFeatureSection',
  );

  const articleStackSection = components.find(
    (component) => component.componentType === 'ArticleStackSection',
  );

  const hasTabController = articleFeatureSection?.tabController?.selectedTab;

  return (
    <PageTemplate
      fpti={fpti}
      subNav={subNav}
      pageInfo={pageInfo}
      aboveHeader={aboveHeader}
      globalDisclosure={globalDisclosure}
      articleStickyButton={articleStickyButton}
    >
      {hasTabController ? (
        <TabControllerTemplate
          articleFeatureSection={articleFeatureSection}
          articleStackSection={articleStackSection}
          pageInfo={pageInfo}
        />
      ) : (
        renderCmsComponents(components, pageInfo)
      )}
    </PageTemplate>
  );
};

CategoryPage.propTypes = pageCommonPropTypes;

export default CategoryPage;
